<div class="loading-overlay">
  <div class="spinner"></div>
  <p class="loading-text" *ngIf="text">{{ text }}</p>
</div>
